// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__WFJ4-","list":"PatternAutocomplete_list__1jVoT"};